import { __decorate, __metadata } from "tslib";
import { Serialize, Type } from '@ftr/serialization';
import { LocalTime } from '@js-joda/core';
import { Money } from '../../type/order';
import { TurnaroundDuration } from '../../type/transcript';
export class Turnaround {
}
__decorate([
    Type(() => TurnaroundDuration),
    __metadata("design:type", TurnaroundDuration
    /**
     * The rate chargeable per minute in whole currency values (e.g.: dollars), expected to be at a maximum of
     * four decimal places.
     */
    )
], Turnaround.prototype, "duration", void 0);
__decorate([
    Type(() => Money),
    __metadata("design:type", Money
    /**
     * The time of day after which orders are treated as being placed on the following day.
     */
    )
], Turnaround.prototype, "rate", void 0);
__decorate([
    Serialize(() => LocalTime),
    __metadata("design:type", Object)
], Turnaround.prototype, "orderCutOff", void 0);
__decorate([
    Type(() => TurnaroundDuration),
    __metadata("design:type", TurnaroundDuration
    /**
     * The number of hours/days before the order due date that a transcript should be submitted
     */
    )
], Turnaround.prototype, "approachingDueOffset", void 0);
__decorate([
    Type(() => TurnaroundDuration),
    __metadata("design:type", TurnaroundDuration)
], Turnaround.prototype, "transcriptDueOffset", void 0);
